import { render } from "./CIS-Content-Carousel-Item.vue?vue&type=template&id=4bc62042&scoped=true"
import script from "./CIS-Content-Carousel-Item.vue?vue&type=script&lang=js"
export * from "./CIS-Content-Carousel-Item.vue?vue&type=script&lang=js"

import "./CIS-Content-Carousel-Item.vue?vue&type=style&index=0&id=4bc62042&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bc62042"]])

export default __exports__